import { gql } from '@apollo/client';

/* ── firm (the organisation this desk belongs to, its people and its clients) ── */

/**
 * The signed-in user's firm and role, in any status: PENDING while the owner
 * has not approved the request yet, null for someone who has no firm.
 */
export const MY_FIRM_MEMBERSHIP = gql`
  query MyFirmMembership {
    myFirmMembership {
      employeeId
      userId
      organizationId
      organizationName
      organizationType
      firmRole
      membershipStatus
      isOwner
      requestedAt
      reviewedAt
    }
  }
`;

/** A firm's people. Members see the approved roster; PENDING is the owner's queue. */
export const FIRM_MEMBERS = gql`
  query FirmMembers($organizationId: Int!, $status: FirmMembershipStatusEnum) {
    firmMembers(organizationId: $organizationId, status: $status) {
      employeeId
      userId
      name
      email
      firmRole
      membershipStatus
      isOwner
      requestedAt
    }
  }
`;

/** Firms to request to join, by name (2+ characters). Name and type only. */
export const SEARCH_FIRMS = gql`
  query SearchFirms($name: String!, $limit: Int = 10) {
    searchFirms(name: $name, limit: $limit) {
      organizationId
      name
      organizationType
    }
  }
`;

/** The caller's firm's client links — only APPROVED ones share data. */
export const FIRM_CLIENTS = gql`
  query FirmClients($status: FirmClientStatusEnum) {
    firmClients(status: $status) {
      linkId
      clientUserId
      clientName
      inviteEmail
      invitePhone
      status
      requestedAt
      respondedAt
      revokedAt
      inviteExpiresAt
    }
  }
`;
